var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * @file Tips
 * @author (v_lichaoqing)
 */

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import Popper from 'popper.js';

import { classPrefix } from '../../common/util';

import PopperTips from './PopperTips';

import './Tips.less';

/**
 * 参数说明
 * title             可选，tips显示的内容
 * placement         可选，tips的方向，默认top
 * level             可选，tips的zIndex层级
 * preventOverflowEnabled 可选，tips的是否被overflow遮挡阻碍
 * mouseEnterDelay   可选，鼠标移入后延时多少才显示 Tooltip，单位：ms
 * mouseLeaveDelay   可选，鼠标移出后延时多少才隐藏 Tooltip，单位：ms
 * popperContainerIsBody 可选，tootips的容器是否挂在body上（默认挂在父节点）
 * classPrefix       可选，类名前缀
 */

var Tips = function (_Component) {
    _inherits(Tips, _Component);

    function Tips(props) {
        _classCallCheck(this, Tips);

        var _this = _possibleConstructorReturn(this, (Tips.__proto__ || Object.getPrototypeOf(Tips)).call(this, props));

        _this.onMouseEnterHandler = function () {
            clearTimeout(_this.timer);
            _this.timer = setTimeout(function () {
                _this.setState({ isShowPopper: true });
            }, _this.props.mouseEnterDelay);
        };

        _this.onMouseLeaveHandler = function () {
            clearTimeout(_this.timer);
            _this.timer = setTimeout(function () {
                _this.setState({ isShowPopper: false });
            }, _this.props.mouseLeaveDelay);
        };

        _this.state = {
            isShowPopper: false
        };
        _this.timer = null;
        _this.Popper = null;
        _this.popperElement = null;
        return _this;
    }

    _createClass(Tips, [{
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            this.Popper.destroy();
            this.Popper = null;
        }
    }, {
        key: 'componentDidMount',
        value: function componentDidMount() {
            var _props = this.props,
                preventOverflowEnabled = _props.preventOverflowEnabled,
                placement = _props.placement;

            this.Popper = new Popper(this.operationElement, this.popperElement, {
                placement: this.placementFormate(placement),
                removeOnDestroy: true,
                modifiers: {
                    preventOverflow: { enabled: preventOverflowEnabled },
                    hide: { enabled: preventOverflowEnabled },
                    arrow: {
                        enabled: true,
                        order: 900
                    }
                }
            });
        }
    }, {
        key: 'componentDidUpdate',
        value: function componentDidUpdate() {
            // 组件属性更新后，重新计算弹出层位置
            this.Popper.update();
        }
    }, {
        key: 'placementFormate',
        value: function placementFormate(placement) {
            return placement.replace('-top', '-start').replace('-bottom', '-end').replace('-left', '-start').replace('-right', '-end');
        }
    }, {
        key: 'render',

        // ===
        value: function render() {
            var _classnames,
                _this2 = this;

            var _props2 = this.props,
                style = _props2.style,
                classPrefix = _props2.classPrefix,
                className = _props2.className,
                level = _props2.level,
                popperContainerIsBody = _props2.popperContainerIsBody;

            var cursorCls = classnames((_classnames = {}, _defineProperty(_classnames, classPrefix + '-tips-cursor', true), _defineProperty(_classnames, className, !!className), _classnames));
            var popperCls = classnames({
                'tips-container': true,
                'popper': true,
                'show': this.state.isShowPopper
            });
            return React.createElement(
                'span',
                { className: classPrefix + '-tips-root',
                    style: style,
                    key: 'operationElement',
                    onMouseEnter: this.onMouseEnterHandler,
                    onMouseLeave: this.onMouseLeaveHandler
                },
                React.createElement(
                    'span',
                    { className: cursorCls,
                        ref: function ref(el) {
                            _this2.operationElement = el;
                        }
                    },
                    this.props.children
                ),
                popperContainerIsBody ? React.createElement(
                    PopperTips,
                    { level: level },
                    React.createElement(
                        'span',
                        { ref: function ref(el) {
                                _this2.popperElement = el;
                            },
                            key: 'popperElement',
                            style: level ? { zIndex: level } : null,
                            className: popperCls
                        },
                        this.props.title,
                        React.createElement('span', { className: 'popper__arrow',
                            'x-arrow': ''
                        })
                    )
                ) : React.createElement(
                    'span',
                    { ref: function ref(el) {
                            _this2.popperElement = el;
                        },
                        key: 'popperElement',
                        style: level ? { zIndex: level } : null,
                        className: popperCls
                    },
                    this.props.title,
                    React.createElement('span', { className: 'popper__arrow',
                        'x-arrow': ''
                    })
                )
            );
        }
    }]);

    return Tips;
}(Component);

Tips.propTypes = {
    title: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
    placement: PropTypes.string,
    children: PropTypes.object,
    style: PropTypes.object,
    level: PropTypes.number,
    className: PropTypes.string,
    classPrefix: PropTypes.string,
    preventOverflowEnabled: PropTypes.bool,
    mouseEnterDelay: PropTypes.number,
    mouseLeaveDelay: PropTypes.number,
    popperContainerIsBody: PropTypes.bool
};
Tips.defaultProps = {
    title: '',
    placement: 'top',
    classPrefix: classPrefix,
    level: 1,
    preventOverflowEnabled: true,
    mouseEnterDelay: 0,
    mouseLeaveDelay: 100
};
export default Tips;